import CanonicalRedux from './canonical_redux';

export default CanonicalRedux;
